
import React, { Fragment } from "react";
import _ from "lodash";
import {
  Button,
  IconButton,
  Radio,
  Checkbox,
  RadioGroup,
  FormControlLabel
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { PrimaryButton, SecondaryButton } from "components/Global/Buttons";
import styled from "styled-components";

const DashContainer = styled.div`
width: 100%;
margin-top: 40px;
margin-bottom: 25px;
`;

const PermsSelectContainer = styled.div`
    &&{
        width:25%;
        height: 100%;
        display: inline-block;
        vertical-align: top;
    }
`;

const RadioContainer = styled.div`
    &&{
        color:black;
        height: 100%;
        display:inline-block;
        margin-left: 40px;
    }
`;

const StyledRadio = styled(Radio)`
    &&{
        color: black;
        width:97%;
    }
`;

const QuoteContainer = styled.div`
    &&{
        height: 100%;
        text-align: left;
        display: inline-block;
        color:black;
        margin-right: 30px;
        border-left: 1px solid gray;
    }
`;

const QuoteCheckContainer = styled.div`
    &&{
        padding-left: 20px;
        height: 100%;
        text-align: center;
        display: inline-block;
        color:black;
    }
`;

const StyledCheckbox = styled(Checkbox)`
    &&{
        color:black; 
    }
`;

const SummaryBox = styled.div`
    &&{
        height:100%;
        width:35%;
        display: inline-block;
        vertical-align: top;
    }
`;
const SummaryTitle = styled.div`
    &&{
        color:black;
        margin-bottom: 15px;
    }
`;

const SummaryBody = styled.p`
    margin-bottom: 10px;    
`;

const SectionHeader = styled.p`
    font-size: 20px;
    color: #999999;
`;

const ClearButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const PipelineDealPermissionDash = ({ onClickView, onClickEdit, onClickQuoteStatus, isQuoteStatusChecked, currentPerm, showHeader, onClear, isMinimized, onShow, projectionsEnabled, toggleProjections }) => {
  const isView = currentPerm ? currentPerm.toLowerCase() === "view" : false;
  const isEdit = currentPerm ? currentPerm.toLowerCase() === "edit" : false;

  return (
    <DashContainer style={{ height: isMinimized ? "0px" : "150px", marginLeft: showHeader ? "0px" : "-35px" }}>
      {showHeader && <SectionHeader>
        PIPELINE QUOTES
        <ClearButton onClick={isMinimized ? onShow : onClear}>{isMinimized ? "Add Permissions" : "Clear permissions"}</ClearButton>
      </SectionHeader>}
      {!isMinimized && <>
        <PermsSelectContainer>
          <RadioContainer>
            <p>View</p>
            <StyledRadio checked={isView} onClick={onClickView} />
          </RadioContainer>
          <RadioContainer>
            <p>Edit</p>
            <StyledRadio checked={isEdit} onClick={onClickEdit} />
          </RadioContainer>
        </PermsSelectContainer>
        <QuoteContainer style={{ width: showHeader ? "35%" : "20%" }}>
          <QuoteCheckContainer>
            <div>Projections</div>
            <Checkbox style={{ color: projectionsEnabled ? "" : "black" }} checked={Boolean(projectionsEnabled)} onClick={toggleProjections} />
            <div>Quote Status</div>
            <StyledCheckbox checked={isQuoteStatusChecked} onClick={onClickQuoteStatus} />
          </QuoteCheckContainer>
        </QuoteContainer>
        <SummaryBox style={{ width: showHeader ? "35%" : "50%" }}>
          <SummaryTitle>Summary</SummaryTitle>
          {isView && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view all deal details and quotes on deals they are assigned to</SummaryBody>}
          {isEdit && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view all deal details and edit quotes that they create</SummaryBody>}
          {projectionsEnabled && (isView || isEdit) && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>{`Guest has access to view${isEdit ? " and edit" : ""} projections`}</SummaryBody>}
          {isQuoteStatusChecked && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has access to view quote status</SummaryBody>}
          {!isView && !isEdit && !isQuoteStatusChecked && <SummaryBody style={{ color: showHeader ? "#777777" : "black", fontStyle: "italic" }}>Guest has no permissions</SummaryBody>}
        </SummaryBox>
                       </>}
    </DashContainer>
  );
};

export default PipelineDealPermissionDash;
